const Ttps = ({ value }) => {
  const ttpsString = value.join(", ");

  return <div>{ttpsString}</div>;
};

export default Ttps;
